<button (click)="resend.emit(this.id)"
  mat-button>Resend</button>
<button (click)="cancel.emit(this.id)"
  mat-button>Cancel</button>